import { render, staticRenderFns } from "./MutedFooter.vue?vue&type=template&id=7e65d698&scoped=true&"
import script from "./MutedFooter.vue?vue&type=script&lang=ts&"
export * from "./MutedFooter.vue?vue&type=script&lang=ts&"
import style0 from "./MutedFooter.vue?vue&type=style&index=0&id=7e65d698&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65d698",
  null
  
)

export default component.exports